<app-fieldset-p
   [icon]="'pi pi-wrench'"
   [header]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.CONFIGURATION' | translate"
   class="d-flex flex-column"
   style="max-width: 300px"
>
   <div class="d-flex flex-column" style="max-width: 300px; min-width: 300px">
      <div *ngIf="selectedNode && selectedNode?.type === NodeType.AssignCampaign" class="flex flex-column gap-2 p-3">
         <label class="text-800 font-semibold">{{
            'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.SELECT_CAMPAIGN_PLACEHOLDER' | translate
         }}</label>
         <app-tree-select
            [nodes]="campaignDataFilters"
            [placeholder]="'Seleccione campaña'"
            [enableSearch]="true"
            [enableReset]="true"
            [selectedKeys]="getSelectedCampaignKey()"
            (selectionChange)="onCampaignSelect($event)"
         ></app-tree-select>
      </div>

      <app-dynamic-form
         *ngIf="selectedNode && selectedNode.type !== NodeType.AssignCampaign"
         #nodeForm
         [formFields]="formType"
         [formCols]="12"
         (formValuesChanged)="updateNodeAttributes($event)"
         [reset]="false"
         [submit]="false"
      ></app-dynamic-form>

      <!-- CONDITIONAL SELECTOR -->
      <div
         *ngIf="this.selectedNode && this.selectedNode?.type === NodeType.Conditional"
         class="flex flex-column justify-content-start p-3 m-neg-top-3"
      >
         <p-toast></p-toast>
         <p class="m-neg-3">{{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.NODE_OBJECTIVE' | translate }}</p>
         <div class="flex flex-row">
            <div *ngIf="nameGoalNode === ''" class="rectangle">
               {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.SELECT_TARGET_NODE' | translate }}
            </div>
            <div *ngIf="nameGoalNode !== ''">
               <input
                  pInputText
                  class="custom-input"
                  autocomplete="off"
                  [readonly]="true"
                  [disabled]="true"
                  [value]="nameGoalNode"
               />
            </div>
            <!--<p-speedDial
               class="ml-4"
               showIcon="pi pi-bars"
               [model]="items!"
               direction="down"
               [radius]="80"
            ></p-speedDial>-->
            <p-button [disabled]="false" (onClick)="addGoalNode()" icon="pi pi-plus" styleClass="h-3rem w-3rem ml-4" />
         </div>
      </div>

      <!-- SMS AND EMAILS -->
      <div
         class="m-3 -mt-2 panel-card"
         *ngIf="!loading && this.copiesMessage.length && this.selectedNode && hascopyIds(this.selectedNode?.config!)"
      >
         <div class="border-round border-bluegray-100 rounded border-1 p-3 flex flex-column">
            <p class="m-0 mb-2 font-semibold text-bluegray-800">
               {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.INFORMATION' | translate }}
            </p>
            <p class="m-0 text-bluegray-600">
               {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.MESSAGE_INFO' | translate }}
            </p>
         </div>

         <ng-container *ngFor="let message of this.copiesMessage; let i = index" class="d-flex flex-column gap-2">
            <p-panel
               *ngIf="message && message.typeChanel === 'EMAIL'"
               class="custom-panel mb-2"
               [header]="truncateText(message.asunto)"
               [toggleable]="true"
               [collapsed]="i !== 0"
            >
               <p>
                  <b>{{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.SUBJECT' | translate }}</b> <br />
                  <i>{{ message.asunto }}</i>
               </p>
               <p-divider></p-divider>
               <p>
                  <b>{{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.PRE_HEADER' | translate }}</b> <br />
                  <i>{{ message.preHeader }}</i>
               </p>
               <p-divider></p-divider>
               <p>
                  <b>{{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.MESSAGE' | translate }}</b> <br />
                  <i>{{ message.text }}</i>
               </p>
               <p-divider></p-divider>
               <p-chip label="{{ message.buttonText }}"></p-chip>
               <ng-template pTemplate="icons">
                  <button
                     [pTooltip]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.COPY_MESSAGE' | translate"
                     class="p-panel-header-icon p-link mr-2"
                     (click)="copyText(message.text)"
                  >
                     <span class="pi pi-copy"></span>
                  </button>
               </ng-template>
            </p-panel>

            <p-panel
               *ngIf="message && message.typeChanel === 'SMS'"
               class="custom-panel mb-2"
               [header]="truncateText(message.asunto)"
               [toggleable]="true"
               [collapsed]="i !== 0"
            >
               <p>
                  <b>{{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.MESSAGE' | translate }}</b> <br />
                  <i>{{ message.text }}</i>
               </p>
               <ng-template pTemplate="icons">
                  <button
                     [pTooltip]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.COPY_MESSAGE' | translate"
                     class="p-panel-header-icon p-link mr-2"
                     (click)="copyText(message.text)"
                  >
                     <span class="pi pi-copy"></span>
                  </button>
               </ng-template>
            </p-panel>
         </ng-container>
      </div>

      <!-- CALL NODES -->
      <div *ngIf="selectedNode?.type === NodeType.MakeOutBoundCall" class="px-3 flex flex-column gap-1 -mt-2">
         <p-divider class="w-full -my-2"></p-divider>

         <div *ngIf="selectedNode?.config?.['isRetryFailCalls']">
            <label class="text-800 font-semibold mb-2 block">
               {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.RETRY_TIME_RANGES_LABEL' | translate }}
            </label>

            <div class="flex flex-column gap-2">
               <div
                  *ngFor="let range of retryTimeRanges; let i = index"
                  class="p-3 border-round surface-0 surface-hover cursor-pointer"
                  [ngClass]="{ 'surface-200': range.selected }"
               >
                  <div class="flex align-items-center justify-between mb-2">
                     <div class="flex align-items-center gap-2">
                        <p-checkbox
                           (ngModelChange)="onRetryRangeToggle($event, i)"
                           [(ngModel)]="range.selected"
                           binary
                        ></p-checkbox>
                        <i class="pi pi-clock text-xl text-700"></i>
                        <span class="font-semibold text-700">{{ range.label | translate: { number: i + 1 } }}</span>
                     </div>
                  </div>

                  <div class="flex gap-2 pl-5 align-items-center" *ngIf="range.selected">
                     <p-calendar
                        [(ngModel)]="range.from"
                        (ngModelChange)="onRetryRangeTimeChange(i, 'from', $event)"
                        [timeOnly]="true"
                        [hourFormat]="'24'"
                        [showIcon]="true"
                        iconDisplay="input"
                        inputStyleClass="p-inputtext"
                     />
                     <span>-</span>
                     <p-calendar
                        [(ngModel)]="range.to"
                        (ngModelChange)="onRetryRangeTimeChange(i, 'to', $event)"
                        [timeOnly]="true"
                        [hourFormat]="'24'"
                        iconDisplay="input"
                        [showIcon]="true"
                        inputStyleClass="p-inputtext"
                     />
                  </div>

                  <div class="text-red-500 text-sm pl-5" *ngIf="range.errors?.invalidOrder">
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.INITIAL_TIME_ERROR' | translate }}
                  </div>

                  <div class="text-red-500 text-sm pl-5" *ngIf="range.errors?.overlaps">
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.OVERLAP_ERROR' | translate }}
                  </div>
               </div>
            </div>
         </div>

         <p-divider class="w-full my-1"></p-divider>

         <div class="flex flex-column gap-2">
            <label class="font-semibold mb-2 block">
               {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.LABEL' | translate }}
            </label>

            <!-- Show "Add rule" dashed button -->
            <p-button
               *ngIf="!showAddActionForm"
               class="w-full block"
               icon="pi pi-plus"
               [outlined]="true"
               [label]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.ADD_RULE' | translate"
               (click)="showAddActionForm = true"
            ></p-button>

            <!-- Add Action Form -->
            <div *ngIf="showAddActionForm" class="flex flex-column gap-4 mb-3 border-round bg-blue-50 p-3">
               <div class="flex flex-column">
                  <label for="situation" class="text-blue-800 font-semibold">
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.CONDITION_LABEL' | translate }}
                  </label>
                  <input
                     pInputText
                     type="text"
                     id="situation"
                     class="p-inputtext w-full"
                     [placeholder]="
                        'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.CONDITION_PLACEHOLDER' | translate
                     "
                     [(ngModel)]="newAction.situation"
                  />
               </div>

               <div class="flex flex-column">
                  <label for="action" class="text-blue-800 font-semibold">
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.ACTION_LABEL' | translate }}
                  </label>
                  <p-dropdown
                     class="w-full"
                     styleClass="w-full"
                     [options]="actionOptions"
                     [(ngModel)]="newAction.action"
                     id="action"
                     optionLabel="label"
                     optionValue="value"
                     [placeholder]="
                        'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.ACTION_PLACEHOLDER' | translate
                     "
                  ></p-dropdown>

                  <div *ngIf="newAction.action === 'assignCampaign'" class="mt-2 flex flex-column">
                     <label class="text-blue-800 font-semibold">
                        {{
                           'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.SELECT_CAMPAIGN_LABEL' | translate
                        }}
                     </label>
                     <app-tree-select
                        [nodes]="campaignDataFilters"
                        [placeholder]="
                           'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.SELECT_CAMPAIGN_PLACEHOLDER'
                              | translate
                        "
                        [enableSearch]="true"
                        [enableReset]="true"
                        [selectedKeys]="newAction.campaign ? [newAction.campaign] : []"
                        (selectionChange)="onCampaignTreeSelect($event)"
                     ></app-tree-select>
                  </div>
               </div>

               <p-button
                  severity="secondary"
                  icon="pi pi-plus"
                  class="w-full block"
                  [label]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.SAVE_RULE' | translate"
                  (click)="addAction()"
               ></p-button>
            </div>

            <!-- Action Cards -->
            <div class="flex flex-column gap-4 p-3">
               <div
                  *ngFor="let action of actions; let i = index"
                  class="p-3 border-round bg-blue-50 shadow-1 grid flex-row justify-between align-items-center"
               >
                  <div class="flex flex-column p-0 gap-2 col-10">
                     <div class="flex flex-column gap-0">
                        <label class="text-blue-800 font-semibold pb-1">
                           {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.WHEN_OCCURS' | translate }}
                        </label>
                        <span class="text-800">{{ action.situation }}</span>
                     </div>

                     <div class="flex flex-column gap-0">
                        <label class="text-blue-800 font-semibold pb-1">
                           {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.ACTIONS.SYSTEM_WILL_DO' | translate }}
                        </label>
                        <span class="text-800">{{ getActionLabel(action.action, action.campaign) }}</span>
                     </div>
                  </div>
                  <p-button
                     class="col-2"
                     severity="danger"
                     rounded="true"
                     icon="pi pi-trash"
                     outlined="true"
                     (click)="removeAction(i)"
                  ></p-button>
               </div>
            </div>
         </div>
      </div>

      <!-- WAIT NODES -->
      <app-message-wait-nodes
         *ngIf="selectedNode"
         [selectedNode]="selectedNode"
         (selectedNodeChange)="onSelectedNodeChange($event)"
      ></app-message-wait-nodes>

      <div class="p-3 -mt-6" *ngIf="this.selectedNode?.type === NodeType.OfferPartialPayment">
         <p-messages class="" severity="info" [closable]="true">
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2">
                  <span class="pi pi-info-circle p-1"></span>
                  <span>
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.PARTIAL_PAYMENT_PROPOSAL' | translate }}
                     <b> {{ selectedNode?.config?.['minimumAmount'].amount ?? '0' }} EUR </b>
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.EXPIRATION_DAYS' | translate }}
                     <b
                        >{{ selectedNode?.config?.['expirationDays'] ?? 'N' }} {{ 'DATA.COMMON.TIME.DAYS' | translate }}
                     </b>
                  </span>
               </div>
            </ng-template>
         </p-messages>
      </div>

      <div class="p-3 -mt-6" *ngIf="this.selectedNode?.type === NodeType.Experiment">
         <p-messages class="" severity="info" [closable]="true">
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2">
                  <span class="pi pi-info-circle p-1"></span>
                  <span
                     [ngStyle]="{ 'text-wrap-style': 'pretty' }"
                     [innerHTML]="
                        'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.EXPERIMENT'
                           | translate: { percentage: selectedNode?.config?.['percentage'] ?? '0' }
                     "
                  >
                  </span>
               </div>
            </ng-template>
         </p-messages>
      </div>

      <div class="p-3 -mt-6" *ngIf="this.selectedNode?.type === NodeType.OfferPaymentAgreement">
         <p-messages class="" severity="info" [closable]="true">
            <ng-template pTemplate>
               <div class="p-message flex flex-row gap-2">
                  <span class="pi pi-info-circle p-1"></span>
                  <span>
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.PARTIAL_PAYMENT_PROPOSAL' | translate }}

                     <b
                        >{{ selectedNode?.config?.['numberOfInstalments'] ?? 'N' }}
                        {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.FEE' | translate }}
                     </b>
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.EXPIRATION_DAYS' | translate }}
                     <b>
                        {{ selectedNode?.config?.['expirationDays'] ?? 'N' }}
                        {{
                           selectedNode?.config?.['expirationDays'] === 1
                              ? ('DATA.COMMON.TIME.DAY' | translate)
                              : ('DATA.COMMON.TIME.DAYS' | translate)
                        }}
                     </b>
                     <span [innerHTML]="'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.FROM_DAY' | translate"></span>
                     <b>
                        {{ selectedNode?.config?.['numberOfInstalments'] ?? 'N' }}
                        {{
                           selectedNode?.config?.['numberOfInstalments'] === 1
                              ? ('DATA.COMMON.TIME.MONTH' | translate)
                              : ('DATA.COMMON.TIME.MONTHS' | translate)
                        }} </b
                     >.
                     {{ 'DATA.MODULES.CAMPAINGS.ELEMENTS.NODES.PARAMETERS.EXACT_DAY' | translate }}
                  </span>
               </div>
            </ng-template>
         </p-messages>
      </div>
   </div>
</app-fieldset-p>
